import { isNullOrUndefinedOrEmptyArray } from "../../utils/generalValidators";

const formatList = (array) => {
  if (isNullOrUndefinedOrEmptyArray(array)) {
    return null;
  }

  let map = {};
  let root = null;

  array.forEach((item) => {
    map[item.stepId] = {
      ...item,
      name: item.actualState.name,
      children: [],
      final: item.status === "ACCEPTED",
      initial: item.parentId === null || item.parentId === undefined,
    };
  });

  array.forEach((item) => {
    if (item.parentId !== null && item.parentId !== undefined) {
      if (map[item.parentId]) {
        map[item.parentId].children.push(map[item.stepId]);
      }
    } else {
      root = map[item.stepId];
    }
  });

  return root || map[array[0].stepId];
};

const getStepsByLevel = (treeRoot, level) => {
  if (!treeRoot || treeRoot.numberComputations > level) {
    return [];
  }

  if (level === 0) {
    return [treeRoot];
  }

  let nodesAtCurrentLevel = [];

  const findNodes = (currentNode) => {
    if (currentNode.numberComputations === level) {
      nodesAtCurrentLevel.push(currentNode);
      return;
    }

    if (currentNode.numberComputations < level) {
      currentNode.children.forEach((child) => {
        findNodes(child);
      });
    }
  };

  findNodes(treeRoot);
  return nodesAtCurrentLevel;
};

export default {
  formatList,
  getStepsByLevel,
};
